export default function EnvelopeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1493_3532)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 3.56836V13.4812L12.132 8.64665L11.397 9.23485L15.3026 14.1174H0.697367L4.60302 9.23485L3.86801 8.64665L0 13.4812V3.56835L7.99953 10.5054L16 3.56836ZM15.9994 1.88281V2.32137L7.99991 9.25837L0.000375 2.32138V1.88281H15.9994Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1493_3532">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
